module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.item,
      "rules": _vm.validation,
      "label-width": "220px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "title"
    },
    model: {
      value: (_vm.item.title),
      callback: function($$v) {
        _vm.$set(_vm.item, "title", $$v)
      },
      expression: "item.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Emails",
      "prop": "emails"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "emails",
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "placeholder": "Enter emails"
    },
    model: {
      value: (_vm.item.emails),
      callback: function($$v) {
        _vm.$set(_vm.item, "emails", $$v)
      },
      expression: "item.emails"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Icon",
      "prop": "options.icon"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select an icon"
    },
    model: {
      value: (_vm.item.options.icon),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "icon", $$v)
      },
      expression: "item.options.icon"
    }
  }, _vm._l((_vm.icons), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    }, [_c('span', {
      class: 'fa fa-' + item
    }), _vm._v(" " + _vm._s(item) + "\n        ")])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Confirmation message",
      "prop": "options.successMessage"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "successMessage"
    },
    model: {
      value: (_vm.item.options.successMessage),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "successMessage", $$v)
      },
      expression: "item.options.successMessage"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Target URL after shipment",
      "prop": "options.redirectToUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "redirectToUrl"
    },
    model: {
      value: (_vm.item.options.redirectToUrl),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "redirectToUrl", $$v)
      },
      expression: "item.options.redirectToUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Send button",
      "prop": "options.buttonCaption"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "buttonCaption"
    },
    model: {
      value: (_vm.item.options.buttonCaption),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "buttonCaption", $$v)
      },
      expression: "item.options.buttonCaption"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Next button",
      "prop": "options.nextButtonCaption"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "nextButtonCaption"
    },
    model: {
      value: (_vm.item.options.nextButtonCaption),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "nextButtonCaption", $$v)
      },
      expression: "item.options.nextButtonCaption"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Back button",
      "prop": "options.backButtonCaption"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "backButtonCaption"
    },
    model: {
      value: (_vm.item.options.backButtonCaption),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "backButtonCaption", $$v)
      },
      expression: "item.options.backButtonCaption"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Required * error",
      "prop": "options.requiredFieldCaption"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "requiredFieldCaption"
    },
    model: {
      value: (_vm.item.options.requiredFieldCaption),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "requiredFieldCaption", $$v)
      },
      expression: "item.options.requiredFieldCaption"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Field icon width",
      "prop": "options.iconWidth"
    }
  }, [_c('el-input-number', {
    attrs: {
      "id": "iconWidth",
      "min": 32,
      "max": 300
    },
    model: {
      value: (_vm.item.options.iconWidth),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "iconWidth", $$v)
      },
      expression: "item.options.iconWidth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "options.withSubscription"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "id": "withSubscription"
    },
    model: {
      value: (_vm.item.options.withSubscription),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "withSubscription", $$v)
      },
      expression: "item.options.withSubscription"
    }
  }, [_vm._v("Enable subscription")])], 1), _vm._v(" "), (_vm.item.options.withSubscription) ? _c('el-form-item', {
    attrs: {
      "label": "Checkbox title",
      "prop": "options.subscriptionTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "subscriptionTitle"
    },
    model: {
      value: (_vm.item.options.subscriptionTitle),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "subscriptionTitle", $$v)
      },
      expression: "item.options.subscriptionTitle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item.options.withSubscription) ? _c('el-form-item', {
    attrs: {
      "label": "Checkbox text",
      "prop": "options.subscriptionCheckbox"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "subscriptionCheckbox"
    },
    model: {
      value: (_vm.item.options.subscriptionCheckbox),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "subscriptionCheckbox", $$v)
      },
      expression: "item.options.subscriptionCheckbox"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item.options.withSubscription) ? _c('el-form-item', {
    attrs: {
      "label": "Confirmation email subject",
      "prop": "options.subscriptionConfirmationEmailSubject"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "subscriptionConfirmationEmailSubject"
    },
    model: {
      value: (_vm.item.options.subscriptionConfirmationEmailSubject),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "subscriptionConfirmationEmailSubject", $$v)
      },
      expression: "item.options.subscriptionConfirmationEmailSubject"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item.options.withSubscription) ? _c('el-form-item', {
    attrs: {
      "label": "Confirmation email text",
      "prop": "options.subscriptionConfirmationEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "id": "subscriptionConfirmationEmail"
    },
    model: {
      value: (_vm.item.options.subscriptionConfirmationEmail),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "subscriptionConfirmationEmail", $$v)
      },
      expression: "item.options.subscriptionConfirmationEmail"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item.options.withSubscription) ? _c('el-form-item', {
    attrs: {
      "label": "Success page URL",
      "prop": "options.subscriptionRedirect"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "subscriptionRedirect"
    },
    model: {
      value: (_vm.item.options.subscriptionRedirect),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "subscriptionRedirect", $$v)
      },
      expression: "item.options.subscriptionRedirect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "options.withPaypal"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "id": "withPaypal"
    },
    model: {
      value: (_vm.item.options.withPaypal),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "withPaypal", $$v)
      },
      expression: "item.options.withPaypal"
    }
  }, [_vm._v("Enable paypal")])], 1), _vm._v(" "), (_vm.item.options.withPaypal) ? _c('el-form-item', {
    attrs: {
      "label": "Paypal email",
      "prop": "options.paypalEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "paypalEmail"
    },
    model: {
      value: (_vm.item.options.paypalEmail),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "paypalEmail", $$v)
      },
      expression: "item.options.paypalEmail"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item.options.withPaypal) ? _c('el-form-item', {
    attrs: {
      "label": "Paypal Client ID",
      "prop": "options.paypalClientId"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "paypalClientId"
    },
    model: {
      value: (_vm.item.options.paypalClientId),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "paypalClientId", $$v)
      },
      expression: "item.options.paypalClientId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item.options.withPaypal) ? _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": "Price",
      "prop": "options.paypalPrice"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "paypalPrice",
      "type": "number"
    },
    model: {
      value: (_vm.item.options.paypalPrice),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "paypalPrice", $$v)
      },
      expression: "item.options.paypalPrice"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.item.options.withPaypal) ? _c('el-form-item', {
    attrs: {
      "label": "Enviroment",
      "prop": "options.paypalEnv"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "paypalEnv"
    },
    model: {
      value: (_vm.item.options.paypalEnv),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "paypalEnv", $$v)
      },
      expression: "item.options.paypalEnv"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Sandbox",
      "value": "sandbox"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Production",
      "value": "production"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.accountSettings && _vm.accountSettings.reservation && _vm.accountSettings.reservation.rooms && _vm.accountSettings.reservation.rooms.length) ? _c('div', [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": " ",
      "prop": "options.withReservation"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "id": "withPaypal"
    },
    model: {
      value: (_vm.item.options.withReservation),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "withReservation", $$v)
      },
      expression: "item.options.withReservation"
    }
  }, [_vm._v("Enable reservation")])], 1), _vm._v(" "), (_vm.item.options.withReservation) ? _c('el-form-item', {
    attrs: {
      "label": "Room",
      "prop": "options.reservationRoom"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "paypalEnv"
    },
    model: {
      value: (_vm.item.options.reservationRoom),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "reservationRoom", $$v)
      },
      expression: "item.options.reservationRoom"
    }
  }, _vm._l((_vm.accountSettings.reservation.rooms), function(room) {
    return _c('el-option', {
      key: room._id,
      attrs: {
        "label": room.title,
        "value": room._id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Party size caption",
      "prop": "options.partySizeCaption"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "partySizeCaption"
    },
    model: {
      value: (_vm.item.options.partySizeCaption),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "partySizeCaption", $$v)
      },
      expression: "item.options.partySizeCaption"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reservation date caption",
      "prop": "options.reservationDateCaption"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "reservationDateCaption"
    },
    model: {
      value: (_vm.item.options.reservationDateCaption),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "reservationDateCaption", $$v)
      },
      expression: "item.options.reservationDateCaption"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Reservation time caption",
      "prop": "options.reservationTimeCaption"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "reservationTimeCaption"
    },
    model: {
      value: (_vm.item.options.reservationTimeCaption),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "reservationTimeCaption", $$v)
      },
      expression: "item.options.reservationTimeCaption"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Cancellation text",
      "prop": "options.cancellationText"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "cancellationText",
      "type": "textarea"
    },
    model: {
      value: (_vm.item.options.cancellationText),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "cancellationText", $$v)
      },
      expression: "item.options.cancellationText"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "'No places' message",
      "prop": "options.noPlacesMessage"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "noPlacesMessage",
      "type": "textarea"
    },
    model: {
      value: (_vm.item.options.noPlacesMessage),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "noPlacesMessage", $$v)
      },
      expression: "item.options.noPlacesMessage"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Available party size",
      "prop": "options.availablePartySize"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.item.options.availablePartySize),
      callback: function($$v) {
        _vm.$set(_vm.item.options, "availablePartySize", $$v)
      },
      expression: "item.options.availablePartySize"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "4"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "5"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "6"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "7"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "8"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "9"
    }
  }), _vm._v(" "), _c('div', [_c('el-checkbox', {
    attrs: {
      "label": "10"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "11"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "12"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "14"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "16"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "18"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "20"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "25"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-checkbox', {
    attrs: {
      "label": "30"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "35"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "40"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Permissions",
      "prop": "permissions"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "users",
      "multiple": "",
      "remote": "",
      "filterable": "",
      "remote-method": _vm.loadUsers,
      "placeholder": "Choose users",
      "loading": _vm.loading,
      "value-key": "_id"
    },
    model: {
      value: (_vm.item.users),
      callback: function($$v) {
        _vm.$set(_vm.item, "users", $$v)
      },
      expression: "item.users"
    }
  }, _vm._l((_vm.users), function(item) {
    return _c('el-option', {
      key: item._id,
      attrs: {
        "label": item.username,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "size": "large"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [(_vm.item._id) ? _c('span', [_vm._v("Save")]) : _c('span', [_vm._v("Create")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3718fb7f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Forms/SettingsDialog.vue
// module id = 362
// module chunks = 4